import { render, staticRenderFns } from "./InformationsPersonnelles.vue?vue&type=template&id=2d578f7a&"
import script from "./InformationsPersonnelles.vue?vue&type=script&lang=js&"
export * from "./InformationsPersonnelles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports